module.exports = __webpack_public_path__ + "static/img/5.ff6a18f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel-1/5.jpg
// module id = M3rh
// module chunks = 1